export function setsAreEqual(a, b) {
    if (a.size !== b.size) {
        return false;
    }
    return Array.from(a).every((element) => {
        return b.has(element);
    });
}
